export enum ElementId {
  ProfilePhotoInput = 'profilePhotoInput',
  CoverPhotoInput = 'coverPhotoInput',
}
